import { apiClient } from '@/shared/api/client'
import type { AuthMyProfileResponse, RoleStatusResponse } from '@/features/auth/types'

export const authApi = {
  /**
   * Full profile. The back-end logs USER_LOGGED_IN on every call, so this must be
   * called at most once per account per tab — never on an interval.
   */
  getMyProfile: async (): Promise<AuthMyProfileResponse> =>
    (await apiClient.get<AuthMyProfileResponse>('/Auth_GetMyProfile')).data,

  /**
   * Live role/permission state. Only writes an audit entry when the back-end
   * detects a change, so this is the endpoint that is safe to poll.
   */
  checkRoleStatus: async (): Promise<RoleStatusResponse> =>
    (await apiClient.get<RoleStatusResponse>('/check-role-status')).data,
}
